import dayjs from 'dayjs'

/**
 * Mock Sentry Issues Data - Outbound Workstream
 * Matches the actual API response structure
 */
export const mockSentryIssuesOutbound = {
  success: true,
  issues: [
    {
      id: '6843177830',
      title: 'GeolocationError: Address geocoding failed',
      culprit: '/outbound/routes/planner',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'GeolocationError',
        value: 'Address geocoding failed',
        type: 'GeolocationError',
        filename: 'RoutePlanner.tsx',
        function: 'geocodeAddress',
        in_app_frame_mix: 'in-app-only',
      },
      numComments: 5,
      userCount: 10,
      count: 62,
      firstSeen: dayjs().subtract(2, 'months').toISOString(),
      lastSeen: dayjs().subtract(20, 'minutes').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177830/',
      shortId: 'OUTBOUND-1I1',
      project: {
        id: '4507465295659004',
        name: 'outbound',
        slug: 'outbound',
        platform: 'javascript-react',
      },
      assignedTo: {
        type: 'user',
        name: 'Sarah Williams',
        email: 'sarah.williams@daylight.com',
      },
      isBookmarked: true,
      isSubscribed: true,
      isUnhandled: true,
      hasSeen: true,
      annotations: [],
      logger: '',
      priority: 'high',
      filtered: {
        count: 62,
        userCount: 10,
        firstSeen: dayjs().subtract(2, 'months').toISOString(),
        lastSeen: dayjs().subtract(20, 'minutes').toISOString(),
      },
      lifetime: {
        count: 62,
        userCount: 10,
        firstSeen: dayjs().subtract(2, 'months').toISOString(),
        lastSeen: dayjs().subtract(20, 'minutes').toISOString(),
      },
      enrichedEnvironment: 'PROD',
    },
    {
      id: '6843177831',
      title: "TypeError: Cannot read property 'capacity' of undefined",
      culprit: '/outbound/loads/builder',
      status: 'unresolved',
      level: 'error',
      type: 'error',
      metadata: {
        title: 'TypeError',
        value: "Cannot read property 'capacity' of undefined",
        type: 'TypeError',
        filename: 'LoadBuilder.tsx',
        function: 'calculateCapacity',
        in_app_frame_mix: 'mixed-frames',
      },
      numComments: 2,
      userCount: 5,
      count: 29,
      firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
      lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      permalink: 'https://sentry.io/organizations/daylight/issues/6843177831/',
      shortId: 'OUTBOUND-2J2',
      project: {
        id: '4507465295659004',
        name: 'outbound',
        slug: 'outbound',
        platform: 'javascript-react',
      },
      assignedTo: null,
      isBookmarked: false,
      isSubscribed: false,
      isUnhandled: true,
      hasSeen: false,
      annotations: [],
      logger: '',
      priority: 'medium',
      filtered: {
        count: 29,
        userCount: 5,
        firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      lifetime: {
        count: 29,
        userCount: 5,
        firstSeen: dayjs().subtract(3, 'weeks').toISOString(),
        lastSeen: dayjs().subtract(2, 'hours').toISOString(),
      },
      enrichedEnvironment: 'QA',
    },
  ],
  pagination: {
    nextCursor: null,
    hasMore: false,
    recordCount: 2,
  },
  'x-hits': 2,
  recordCount: 2,
}

export const mockPriorityCountsOutbound = {
  success: true,
  'priority-counts': {
    high: 1,
    medium: 1,
    low: 0,
  },
  'x-hits': 2,
}
